import { useUserCountryQuery } from "@bridgesplit/abf-react";

const X_STOCKS_MINTS = [
    "XsoCS1TfEyfFhfvj8EtZ528L3CaKBDBRqRapnBbDF2W",
    "XsueG8BtpquVJX9LVLLEGuViXUungE6WmK5YZ3p3bd1",
    "XsbEhLAtcf6HdfpFZ5xEMdqW8nfAvcsP5bdudRLJzJp",
    "Xsc9qvGR1efVDFGLrVsmkzv3qi45LTBjeUKSPmx9qEh",
    "XsDoVfqeBukxuZHWhdvWHBhgEHjGNst4MLodqsJHzoB"
];

const GEOBLOCKED_MINTS_BY_COUNTRY_CODE: Record<string, string[]> = {
    US: X_STOCKS_MINTS
};

function getBlockedMintsForCountry(country: string | undefined): string[] {
    if (!country || !GEOBLOCKED_MINTS_BY_COUNTRY_CODE[country]) {
        return [];
    }
    return GEOBLOCKED_MINTS_BY_COUNTRY_CODE[country];
}

export function useUserGeoblockedAssets() {
    const {
        data: country,
        isLoading,
        isError
    } = useUserCountryQuery(undefined, {
        refetchOnMountOrArgChange: false
    });

    const blockedMints = getBlockedMintsForCountry(country?.country_code);

    return {
        blockedMints,
        isLoading,
        isError,
        isBlocked: (mint: string | undefined | null) => !!mint && blockedMints.includes(mint)
    };
}
